import { ZONE_MAPSTYLE } from '@popety_io/popety-io-lib'

export { default } from './LandSummary'

export const LandSummaryMapConfig = { style: ZONE_MAPSTYLE }
